<template>
  <a-modal 
    :visible="visible" 
    :title="title"
    :width="800"
    :forceRender="true"
    @ok="ok"
    @cancel="cancel"
    destroyOnClose
  > 
    <a-table
      :columns="columns"
      :data-source="list"
      :pagination="false"
      :row-selection="rowSelection"
      :scroll="{y: 200}"
      row-key="factoryId"
    >
      <template slot="tooltip" slot-scope="text">
        <a-tooltip>
          <template slot="title">
            {{text}}
          </template>
          {{text}}
        </a-tooltip>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import { getRequest } from "@/components/Common/Utils/Utils";
export default {
  props: ['visible','productIds','reasonList','rowData'],
  data() {
    return {
      title: <p>EBS校验<span class='modalTitle'>选择指定工厂进行EBS库存校验</span></p>,
      labelTitle: <span style={{fontWeight: 'bold'}}>本次配方调整原因</span>,
      form: this.$form.createForm(this),
      list: [],
      columns: [
        {
          title: '工厂名称',
          dataIndex: 'name',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'tooltip' },
        },
        {
          title: '工厂编号',
          dataIndex: 'code',
          width: 90,
          ellipsis: true,
        },
        {
          title: 'EBS实体编码',
          dataIndex: 'ebsEntityCode',
          width: 90,
          ellipsis: true,
        },
        {
          title: 'EBS库存名称',
          dataIndex: 'ebsMaterialName',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'tooltip' },
        },
        {
          title: 'EBS库存编码',
          dataIndex: 'ebsMaterialCode',
          width: 90,
          ellipsis: true,
        },
      ],
      pagination: {
        total:0,
        pageSize:20,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.getList({current,pageSize})
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this.getList({current: 1,pageSize})
        } //每页多少条
      },
      selectedRowKeys:[],
      formulaId: getRequest('id')
    }
  },
  watch: {
    visible(val){
      if(val){
        this.selectedRowKeys = []
        this.getList(true)
      }
    }
  },
  computed:{
    rowSelection(){
      return{
        type: 'radio',
        onChange: (selectedRowKeys) => {
          this.selectedRowKeys = selectedRowKeys
        },
        selectedRowKeys:this.selectedRowKeys
      }
    }
  },
  methods:{
    ok(){
      let ebsPushFactoryId = ''
      if(this.list.length === 0){
        ebsPushFactoryId = window.localStorage.getItem('factoryId')
      }else{
        if(this.selectedRowKeys){
          ebsPushFactoryId = this.selectedRowKeys.join(',')
        }
      }
      if(!ebsPushFactoryId) {
        this.$message.warning('请选择关联工厂')
        return
      }
      let params = {
        formulaId: this.formulaId,
        ebsPushFactoryId
      }
      this.$http.get('/nhf-app/formulaNhf/batchFormulaRawEbsCheck',{params}).then(res => {
        let {data} = res || {}
        // let feild = 'warning'
        // if(success) feild = 'success'
        // this.$message[feild](msg)
        this.$emit('checkEbsRes',data)
        this.$emit('close', true);
      })
    },
    cancel(){
      this.$emit('close', false);
    },
    getList(isFirst){
      let params = {
        factoryId: window.localStorage.getItem('factoryId')
      }
      this.$http.get('/iot-factory/factorysublink/subFactoryList',{params}).then(res => {
        let {data,success} = res || {}
        if(success) {
          this.list = data || []
          if(isFirst && (data && data.length > 0)) this.selectedRowKeys = [data[0].factoryId] || []
        }
      })
    }
  }
}
</script>
<style lang="scss">
  .pushEbsStyle{
    margin-top: 20px;
    .ant-checkbox-wrapper + .ant-checkbox-wrapper{
      margin-left: 0;
    }
  }
</style>